(function () {
  'use strict';

  var STORAGE_KEY = 'mm_wishlist';

  // ── Storage ──────────────────────────────────────────────────
  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }
  function saveList(list) { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
  function isInList(id) { return getList().some(function(p) { return String(p.id) === String(id); }); }

  // ── Money ────────────────────────────────────────────────────
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + '\u00A0€'; }

  // ── Count badges ─────────────────────────────────────────────
  function updateCount() {
    var n = getList().length;
    document.querySelectorAll('.wl-count-bubble').forEach(function(el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
    var hc = document.getElementById('wl-header-count');
    if (hc) hc.textContent = n;
  }

  // ── Button states ────────────────────────────────────────────
  function updateBtns(id, active) {
    document.querySelectorAll('[data-wl-product="' + id + '"]').forEach(function(btn) {
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // ── Add / Remove ─────────────────────────────────────────────
  function trackWishlist(data) {
    var minPrice = data.variants && data.variants.length
      ? (Math.min.apply(null, data.variants.map(function(v) { return v.price; })) / 100).toFixed(2)
      : '';
    try {
      fetch('https://mm-analytics.onrender.com/wishlist-track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ secret: 'mm2026voyage', event: 'add',
          product_id: String(data.id), product: data.title || '',
          vendor: data.vendor || '', price: minPrice })
      });
    } catch(e) {}
  }

  function addProduct(data) {
    var list = getList();
    if (!list.some(function(p) { return String(p.id) === String(data.id); })) {
      list.push({ id: data.id, handle: data.handle, title: data.title, vendor: data.vendor,
        url: data.url, image: data.image, tags: data.tags || [], variants: data.variants, note: '' });
      saveList(list);
      trackWishlist(data);
    }
    updateCount();
    updateBtns(data.id, true);
  }

  function removeProduct(id) {
    saveList(getList().filter(function(p) { return String(p.id) !== String(id); }));
    updateCount();
    updateBtns(id, false);
    renderItems();
  }

  // ── Cashback eligibility ─────────────────────────────────────
  function hasCashback(product) {
    var t = product.tags || [];
    return t.indexOf('Carte cadeau') === -1 && t.indexOf('prix-dynamique') === -1;
  }

  // ── Render drawer items ──────────────────────────────────────
  function renderItems() {
    var container = document.getElementById('wl-items-container');
    if (!container) return;
    var list = getList();

    if (list.length === 0) {
      container.innerHTML = '<p class="wl-empty">Votre liste de favoris est vide.</p>';
      return;
    }

    var html = list.map(function(p) {
      var minPrice = Math.min.apply(null, p.variants.map(function(v) { return v.price; }));
      var cb = hasCashback(p);

      var variantRows = p.variants.map(function(v) {
        return '<div class="wl-variant-row">'
          + '<span class="wl-vname">' + escHtml(v.title) + '</span>'
          + '<span class="wl-vprice">' + money(v.price) + '</span>'
          + (cb ? '<span class="wl-vcb">Cagnotte\u00A0<strong>' + money(Math.round(v.price * 0.1)) + '</strong></span>' : '')
          + '<button class="wl-vadd-btn" data-variant="' + v.id + '" data-product="' + p.id + '"'
          + (v.available ? '' : ' disabled') + '>'
          + (v.available ? 'Ajouter' : '\u00C9puis\u00E9') + '</button>'
          + '</div>';
      }).join('');

      return '<div class="wl-item" data-wl-item="' + p.id + '">'
        + '<div class="wl-item-top">'
        + '<a href="' + p.url + '" class="wl-thumb-link">'
        + '<img src="' + p.image + '" alt="' + escHtml(p.title) + '" class="wl-thumb" loading="lazy">'
        + '</a>'
        + '<div class="wl-item-meta">'
        + '<span class="wl-vendor">' + escHtml(p.vendor) + '</span>'
        + '<a href="' + p.url + '" class="wl-title">' + escHtml(p.title) + '</a>'
        + '<span class="wl-price">\u00C0 partir de ' + money(minPrice) + '</span>'
        + (cb ? '<span class="wl-cashback">Cagnotte\u00A0<strong>' + money(Math.round(minPrice * 0.1)) + '</strong></span>' : '')
        + '</div>'
        + '<div class="wl-item-btns">'
        + '<button class="wl-expand-btn" data-wl-expand="' + p.id + '" aria-label="Voir les variantes">'
        + '<svg width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M4 7l5 5 5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        + '</button>'
        + '<button class="wl-del-btn" data-wl-del="' + p.id + '" aria-label="Retirer">'
        + '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'
        + '</button>'
        + '</div>'
        + '</div>'
        + '<div class="wl-item-body" id="wl-body-' + p.id + '" style="display:none">'
        + '<div class="wl-variants">' + variantRows + '</div>'
        + '<button class="wl-cart-btn" data-variant="' + p.variants[0].id + '" data-product="' + p.id + '">'
        + '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>'
        + ' Ajouter au panier'
        + '</button>'
        + '</div>'
        + '</div>';
    }).join('');

    container.innerHTML = html;

    // Bind expand
    container.querySelectorAll('[data-wl-expand]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var id = this.dataset.wlExpand;
        var body = document.getElementById('wl-body-' + id);
        var open = body.style.display !== 'none';
        body.style.display = open ? 'none' : 'block';
        this.classList.toggle('is-open', !open);
      });
    });

    // Bind delete
    container.querySelectorAll('[data-wl-del]').forEach(function(btn) {
      btn.addEventListener('click', function() { removeProduct(this.dataset.wlDel); });
    });

    // Bind add-to-cart buttons (variant rows + main button)
    container.querySelectorAll('[data-variant]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (this.dataset.variant) addToCart(this.dataset.variant, this);
      });
    });
  }

  // ── Add to cart ───────────────────────────────────────────────
  function addToCart(variantId, btn) {
    var orig = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    }).then(function(r) {
      if (r.ok) {
        btn.innerHTML = '\u2713 Ajout\u00E9';
        fetch('/cart.js').then(function(r2) { return r2.json(); }).then(function(cart) {
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function(el) {
            el.textContent = cart.item_count;
          });
        });
        setTimeout(function() { btn.innerHTML = orig; btn.disabled = false; }, 2000);
      } else {
        btn.innerHTML = 'Erreur'; btn.disabled = false;
      }
    }).catch(function() { btn.innerHTML = 'Erreur'; btn.disabled = false; });
  }

  // ── Escape HTML ───────────────────────────────────────────────
  function escHtml(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  // ── Drawer ────────────────────────────────────────────────────
  function openDrawer() {
    renderItems(); updateCount();
    var el = document.getElementById('wishlist-drawer');
    if (el) { el.classList.add('is-open'); document.body.classList.add('wl-body-open'); }
  }
  function closeDrawer() {
    var el = document.getElementById('wishlist-drawer');
    if (el) { el.classList.remove('is-open'); document.body.classList.remove('wl-body-open'); }
  }

  // ── Init ──────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function() {
    updateCount();

    // Open triggers
    document.querySelectorAll('[data-wl-open]').forEach(function(el) {
      el.addEventListener('click', function(e) { e.preventDefault(); openDrawer(); });
    });

    // Close button
    var closeBtn = document.getElementById('wl-close-btn');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    // Overlay
    var overlay = document.getElementById('wl-overlay');
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Explore button
    var exploreBtn = document.getElementById('wl-explore-btn');
    if (exploreBtn) exploreBtn.addEventListener('click', closeDrawer);

    // Initial state for heart buttons
    document.querySelectorAll('[data-wl-toggle]').forEach(function(btn) {
      var data;
      try { data = JSON.parse(btn.dataset.wlToggle); } catch(e) { return; }
      if (isInList(data.id)) { btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
    });

    // Capture phase — intercepts clicks before card overlay (a::after z-index:1)
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-wl-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var data;
      try { data = JSON.parse(btn.dataset.wlToggle); } catch(err) { return; }
      if (isInList(data.id)) { removeProduct(data.id); } else { addProduct(data); }
    }, true);
  });

  window.MM_Wishlist = { add: addProduct, remove: removeProduct, open: openDrawer, close: closeDrawer };
})();
